import { useNavigate, useParams } from 'react-router-dom';
import { ProfileExample } from '../../components/profile/ProfileExample';
import { CheckIsBlocked } from './CheckIsBlocked';
import useAxiosPrivate from '../../hooks/useAxiosPrivate';
import chatService from '../../services/chat.service';
import { toast } from 'react-toastify';
import config from '../../config';

export function ProfileChat() {
  const { id: userId } = useParams();

  const axiosPrivate = useAxiosPrivate();
  const navigate = useNavigate();

  const handleToFindOrCreateChat = async () => {
    if (!userId) return;
    try {
      const res = await chatService.getChatToUserId(axiosPrivate, userId);
      navigate(config.ROUTES.CHATS.TEXT(res.data._id));
    } catch (error) {
      console.error('[Roulette] getChatToUserId:', error);
      toast.error('Ошибка при попытке открыть чат с пользователем');
    }
  };

  return (
    <CheckIsBlocked userId={userId}>
      <ProfileExample className="h-[75%] overflow-scroll rounded-[16px] !p-0" userId={userId} />
      <button
        onClick={handleToFindOrCreateChat}
        className="flex items-center justify-center gap-1 rounded-full bg-[#A1F69E] text-black p-[18.5px] m-4"
      >
        <img src="/icons/chat-bubble-typing.svg" alt="chat-bubble-typing" />
        Написать
      </button>
    </CheckIsBlocked>
  );
}
